import flgService from '../services/flg.service'

const handlers = {
  flg: {
    session: {
      set: 'flg_session_set'
    }
  }
}

const initVuexState = function(state) {
  state.flg = {
    session: null
  };
}

const initGetters = function(getters) {
  getters.flg = (state => state.flg);
}

const initActions = function(actions) {
  actions[handlers.flg.session.set] = ({ commit }, session) => commit(handlers.flg.session.set, session);
}

const initMutations = function(mutations) {
  mutations[handlers.flg.session.set] = (state, session) => state.flg.session = session;
}

const initAppState = function(appState, store) {
  appState.flg = {
    session: {
      get: () => store.getters.flg.session,
      open: async (gameId, language, isMobile, backUrl) => {
        let session = await flgService.openSession(gameId, language, isMobile, backUrl);
        store.dispatch(handlers.flg.session.set, session);
      },
      openDemo: async (gameId, language, isMobile, backUrl) => {
        let session = await flgService.openDemoSession(gameId, language, isMobile, backUrl);
        store.dispatch(handlers.flg.session.set, session);
      },
      close: async () => {
        if (store.getters.flg.session) {
          await flgService.closeSession();
        }
        store.dispatch(handlers.flg.session.set, null);
      }
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/flg.js